import {h, Component} from 'preact';
import PickListItem from '../Item';
import {withPickList} from '../index';
import FilterList from '@components/common/FilterList';
import invoke from 'lodash.invoke';

class PickList extends Component {

    static defaultProps = {
        maxResultCount: 7,
        enableSearchAtCount: 11,
        queryProps: [],
        searchPlaceholder: null
    };

    onResultSelect = ( evt, result ) => {
        const {pickList} = this.props;
        invoke( pickList.actions, 'handleItemChange', result[pickList.itemIdProp] );
    };

    /**
     * Sort pluck current selectedItem from list and shift to front to improve user interaction
     */
    shiftSelectedItem ( list, selectedItem ) {
        if ( !selectedItem ) {
            return list;
        }

        const itemId = this.props.pickList.itemIdProp;
        const filteredList = list.filter( item => item[itemId] !== selectedItem[itemId] );
        return [selectedItem].concat( filteredList );
    }

    render () {
        const {pickList, itemRenderer, maxResultCount, searchPlaceholder, enableSearchAtCount, queryProps} = this.props;
        if ( !pickList.isEditing || pickList.list.length <= 0 ) {
            return null;
        }

        const sortedList = this.shiftSelectedItem( pickList.list, pickList.selectedItem );
        const listItemRenderer = item => <PickListItem {...item} renderer={itemRenderer}/>;

        return (
            <div data-testid="picklist-list">
                {pickList.allowAddItem &&
                <div onClick={pickList.actions.toggleAddItem} className="button-add-item">
                    ＋ Add another {pickList.itemType}
                </div>
                }

                <FilterList
                    onResultSelect={this.onResultSelect}
                    list={sortedList}
                    queryProps={queryProps}
                    renderer={listItemRenderer}
                    searchPlaceholder={searchPlaceholder}
                    maxResultCount={maxResultCount}
                    enableSearchAtCount={enableSearchAtCount}/>
            </div>

        );
    }
}

export default withPickList( PickList );